const HelperUtil = {
    naiveRound(num, decimalPlaces = 0) {
        var p = Math.pow(10, decimalPlaces);
        return Math.round(num * p) / p;
    },
    formatDate(rawDate) {
        if (rawDate !== undefined) {
            const dateObj = new Date(rawDate);
            return dateObj.toISOString().split('T')[0]
        } else {
            return "N/A"
        }

    }
};
export default HelperUtil;
